// Feed rows shown in the phone + console product mockups.
// Pure data — no React, no JSX.

export type AvatarColor = 'av-terra' | 'av-moss' | 'av-glow' | 'av-warm' | 'av-mossd';

export type PlatformCode = 'SCD' | 'APL' | 'YTM' | 'DZR' | 'SPO';

export interface FeedRow {
  initial: string;
  color: AvatarColor;
  name: string;
  pf: PlatformCode;
  when: string;
  track: string;
  artist: string;
}

export const FEED_ROWS: FeedRow[] = [
  { initial: 'L', color: 'av-terra', name: 'Léo',   pf: 'SCD', when: '4 min',  track: 'Black Classical Music',    artist: 'Yussef Dayes' },
  { initial: 'M', color: 'av-moss',  name: 'Mira',  pf: 'APL', when: '12 min', track: 'Journey in Satchidananda', artist: 'Alice Coltrane' },
  { initial: 'S', color: 'av-glow',  name: 'Sami',  pf: 'YTM', when: '28 min', track: 'Crush — live, Maida Vale', artist: 'Floating Points' },
  { initial: 'N', color: 'av-warm',  name: 'Nawel', pf: 'DZR', when: '1 h',    track: 'Águas de Março',           artist: 'Elis Regina & Tom Jobim' },
];
